import styled from '@emotion/styled';
import { useSendingLeadConversionAPI } from 'hooks/api';
import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';

interface MetaPrams {
  source?: string,
  medium?: string,
  fbclid?: string,
  content?: string,
}


const First:React.FC<any> = () => {
  const [param, setParam] = useState<MetaPrams>({
    source: "",
    medium: "",
    fbclid: "",
    content: "",
  });

  const { mutateAsync: postLeadConversionAPI  } = useSendingLeadConversionAPI();
  
  const getFbclidFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // return urlParams.get('fbclid');
    return {
      source: urlParams.get('utm_source') || "",
      medium: urlParams.get('utm_medium') || "",
      fbclid: urlParams.get('fbclid') || "",
      content: urlParams.get('utm_content') || ""
    }
  }

  useEffect(() => {
    const metaClickId = getFbclidFromUrl();
    if (metaClickId) {
      setParam(metaClickId)
    }
  },[])

  // const fbclid = param.fbclid;
  // const source = param.source;
  // const medium = param.medium;
  // const content = param.content;

  const handleAppStore = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'appStore',
      "city": "KR",
      "gender" : "female"
    })
    
    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
  }

  const handleGoogle = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'googlePlayStore',
      "city": "KR",
      "gender" : "female"
    })


    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
  }

  return (
    <Container>
      <BodyImgContainer>
        <Img src="/images/newLanding/landingApp/1541.png"/>
      </BodyImgContainer>
      <Text1>
        번거로운 과정은 다 빼고<br/> 꼭 필요한 것만 남겼습니다.
      </Text1>
      <SmallText>
      모든 번거로움으로부터의 해방
      <br/>사진을 고르는 행복만 느끼세요
      </SmallText>
      <DownloadBoxContainer>
        <DownloadBox className="app"
          onClick={handleAppStore}
        >
          <DownloadLogo>
            <Img src="/images/newLanding/home/appstore.png"/>
          </DownloadLogo>
          APP STORE
        </DownloadBox>
        <DownloadBox 
          className="googleButton"
          onClick={handleGoogle}
          >
          <DownloadLogo>
            <Img src="/images/newLanding/home/googleplay.png"/>
          </DownloadLogo>
          GOOGLE PLAY
        </DownloadBox>
      </DownloadBoxContainer>
    </Container>
  )
}

export default First;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;


const Img = styled.img`
  width: 100%;
`;

const BodyImgContainer = styled.div`
  width: 90%;
  margin: 0 auto;
`
const Text1 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;
  font-weight: 600;
  text-align: center;
`;

const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 30px;
  text-align: center;
`

const DownloadBoxContainer = styled.div`
  margin: 0 auto 60px;
  width: 330px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DownloadBox = styled.button`
  margin-top: 10px;
  height: 50px;
  border: 1px solid  lightgrey;
  border-radius: 5px;
  &.app{
    font-size: 14px;
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: black;
    background-color: white;
  }
  &.googleButton{
    font-size: 14px;
    width: 170px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: black;
    background-color: white;
  }
`;

const DownloadLogo = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;